import { Options, Splide } from '@splidejs/splide';

import { layout } from '../../helpers/layout';

export interface MyOptions extends Options {
  checkOverflow?: boolean;
  // Set when every slide in this carousel is known to render at the same width (e.g.
  // repeated cards from the same template). Lets getPerPage() skip reading offsetWidth
  // on every slide - a forced-layout read - in favor of reading just one.
  uniformWidth?: boolean;
}

export class MySplide {

  private instance;
  private slides;

  constructor(slider, private options: MyOptions) {
    this.instance = new Splide(slider, options);
  }

  mount(): void {
    this.instance.mount();
    if (this.options.autoWidth === true) {
      this.watchArrows();
    }
  }

  destroy(): void {
    this.instance.destroy();
  }

  sync(slider: MySplide): MySplide {
    return this.instance.sync(slider.instance);
  }

  updateOptions(): void {
    const perPage = this.getPerPage();
    this.instance.options = {
      ...this.options,
      perPage
    };
  }

  onMoved(callback): void {
    this.instance.on('moved mounted', () => {
      if (!this.instance.Components || !this.instance.Components.Elements.list) {
        return;
      }
      callback(this.instance.Components.Elements.list.children[this.instance.index]);
    });
  }

  private getPerPage(): number {
    this.slides = this.instance.Components.Elements.slides;
    const track = this.instance.Components.Elements.track;
    if (!track || !this.slides || !this.slides.length) {
      return 0;
    }
    const averageSlideWidth = this.options.uniformWidth === true
      ? this.slides[0].offsetWidth
      : this.slides.reduce((slidesWidth, slide) => slidesWidth + slide.offsetWidth, 0) / this.slides.length;

    return Math.floor(track.offsetWidth / averageSlideWidth);
  }

  private watchArrows(): void {
    this.updateOptions();
    layout.addWindowResizeHandler(this.instance.root.id, this.updateOptions.bind(this));
  }

}

window['MySplide'] = MySplide;
